import styled from 'glamorous'
import map from 'lodash/map'
import PerfectScrollbar from 'react-perfect-scrollbar'

import { $ } from 'utils'
import { withRouter } from 'react-router-dom'

import FaceListItem from './FaceListItem'

const ListContainer = styled(PerfectScrollbar)({
  display: 'flex',
  alignItems: 'flex-start',
  alignContent: 'flex-start',
  marginLeft: -6,
  flexWrap: 'wrap',
  overflow: 'auto',
  height: '100%',
}, 'lists-scrollable')

const FacesList = ({ descriptors, match }) =>
  $(ListContainer,
    map(descriptors.items, (descriptor) =>
      $(FaceListItem, {
        key: descriptor.uuid,
        descriptor,
        selected: match.params.id === descriptor.uuid,
      })
    )
  )

export default withRouter(FacesList)



// WEBPACK FOOTER //
// ./src/pages/Faces/FacesList.js